module.exports = __webpack_public_path__ + "img/1.e0031018.png";